<template>
  <span class="input-password">
      <input
          :id="id"
          :type="inputType"
          :value="inputValue"
          :placeholder="customplaceholder || $lang.messages.kid.login.pas_placeholder"
          class="form-control"
          :class="className ? className : ''"
          @input="changePassword($event.target.value)"
          :disabled="disabled"
          autocomplete="none"
          :maxlength="maxLength">
      <button class="btn-icon" @click="pasVisible = !pasVisible">
        <i class="icon-visible" v-if="pasVisible"></i>
        <i class="icon-hidden" v-if="!pasVisible"></i>
      </button>
    </span>
</template>

<script>

export default {
  name: 'InputPassword',
  props: ['value', 'disabled', 'customplaceholder', 'passwordVisible', 'maxLength', 'className', 'id'],
  data: function () {
    return {
      inputValue: this.value || '',
      pasVisible: this.passwordVisible || false,
    }
  },
  computed: {
    inputType (){
      return this.pasVisible ? 'text' : 'password'
    }
  },
  methods: {
    changePassword(value){
      this.inputValue = value;
      this.$emit('changepassword', value);
    },
  }
}

</script>

<style lang="scss">
.input-password {
  position: relative;
  width: 100%;

  .form-control {
    padding-right: 35px;
  }

  .btn-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);

    &:focus {
      outline: none;
    }
  }
}
</style>
